import '../../stylesheets/CardPage.css';
import { selectAllStrings } from '../language/languageSlice';
import { selectUserData, fetchUserData } from '../user/userSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { getCardStatus } from '../../api/mobile';
import Navbar from '../../app/Navbar';
import BuyAccessButton from '../../components/BuyAccessButton';

const CardPage = () => {
    const cardData = useSelector(state => state.user.cardData);
    const strings = useSelector(selectAllStrings);
    const profile = useSelector(selectUserData);
    const profileStatus = useSelector(state => state.user.userData.status);
    const profileError = useSelector(state => state.user.userData.error);
    const [cardStatus, setCardStatus] = useState(null);
    const expire = new Date(cardData.expire_card);
    const issueDate = new Date(profile.emission_date);
    const dispatch = useDispatch();

    const parseDate = date => (date.getMonth() < 8 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '/' + date.getFullYear().toString().substring(2);

    useEffect(async () => {
        let status;
        if (cardStatus === null) {
            status = await getCardStatus();
            setCardStatus(status);
        }
        if (cardStatus !== null && profileStatus === 'idle') {
            dispatch(fetchUserData({cardNumber: cardStatus.cardNumber, password: cardStatus.password}));
        }


    }, [dispatch, profileStatus, cardStatus]);
    
  



    return <div id="card_page">
        <div className="content">
            <h1>{strings.your_club_card}</h1>
        </div>
        {cardData.profile_id ? profileError ? <div>{profileError}</div> :
                        profileStatus === 'loading' ? <div className="loader"></div> : <div>
                            <div id="card_front">
                                <img alt="card" src="/images/CLUB_new.jpg"/>
                                <div className="info">
                                    <div className="name">{profile.user ? `${profile.first_name} ${profile.last_name}` : null}</div>
                                    <div className="card-number">TESSERA Nº{cardStatus ? cardStatus.cardNumber : null}</div>
                                    <div className="issued">EMESSA {parseDate(issueDate)}</div>
                                    <div className="expire">
                                        VALIDA FINO A {parseDate(expire)}
                                    </div>
                                </div>
                    
                            </div>
                        </div> : <div className="content" id="personal_information">{strings.you_using_trial}
                            <BuyAccessButton/>
    </div>}
        <Navbar/>
    </div>;
};

export default CardPage